import $ from 'jquery';
import bootstrap from 'bootstrap';
import Modernizr from './modernizr.js';
import Echo from "laravel-echo";
import Pusher from 'pusher-js';
import { flare } from '@flareapp/js'; 

// important for jQuery to work for other scripts!
global.$ = global.jQuery = require('jquery');
global.Popper = require('popper.js').default;

var scrollAmount;

// Initialize Flare only in production
if (process.env.NODE_ENV === 'production') {
    try {
        flare.light();
    } catch (error) {
        console.error("Flare initialization error:", error);
    }
}

var MobileResponsive = (function() {
    var VisibleState = Object.freeze({
        CLOSED: 0,
        OPEN: 1
    });

    // default inital states
    var ElementState = {
        hamburger: function() {
            if ($('.header__hamburger').attr("aria-expanded","true")) {
                return VisibleState.OPEN;
            } else {
                return VisibleState.CLOSED;
            }
        },
    };

    function isMobileSite() {
        return $('.header__hamburger').is(':visible') || $(window).width() <= 767;
    }

    // the actual opening/closing of the hamburger is handled by Bootstrap
    // below is just for animation
    function hamburgerToggleActivated() {
        if (!$('.header__navbar').hasClass("show")) {
            $('.header__navbar').addClass('collapsing');

            setTimeout(function() {
                $('.header__navbar').addClass('show').removeClass('collapsing');
                scrollAmount = (document.documentElement.scrollTop||document.body.scrollTop);
                $('body').css({top: -scrollAmount}).addClass('modal-open');
            }, 20);

        } else {
            $('.header__navbar').addClass('collapsing');
            $('html, body').removeClass('modal-open').css({top: ''}).scrollTop(scrollAmount);
            setTimeout(function() {
                $('.header__navbar').removeClass('show').removeClass('collapsing');
            }, 20);
        }
    }

    // toggle search bar
    function toggleSearch(){
        if($('#full-screen-search').hasClass('open')){
            $('body').removeClass('modal-open');
            $('#full-screen-search').removeClass('open');

        } else {
            $('#full-screen-search').addClass('open');
            $('body').addClass('modal-open');
            setTimeout(function(){$('#full-screen-search #term').focus();},300);
        }
    }

    function setupMobileResponsive() {
        // setup ancillary event handler for hamburger click
        $('.header__hamburger').on('click', hamburgerToggleActivated);
        $('.header__close').on('click', hamburgerToggleActivated);

        // floating labels!
        $('.floating-input').keyup(function(){
            var element = $(this).attr('name');
            if(element){
                // regex for square brackets in names in the funnel
                var regex = /(.*)\[([^)]+)\]/;
                var regexArray = element.match(regex);
                if(regexArray && regexArray.length > 0){
                    element = regexArray[1] + "\\[" + regexArray[2] + "\\]";
                }
            }
            // hide
            if(!$.trim(this.value).length) {
                $("." + element + "-label").removeClass('floating');
                $(this).removeClass('floating');
            // show labels
            } else {
                $("." + element + "-label").addClass('floating');
                $(this).addClass('floating');
            }
        });

        $(".floating-input").each(function() {
            var element = $(this).attr('name');
            // regex for square brackets in names in the funnel
            if(element){
                var regex = /(.*)\[([^)]+)\]/;
                var regexArray = element.match(regex);
                if(regexArray && regexArray.length > 0){
                    element = regexArray[1] + "\\[" + regexArray[2] + "\\]";
                }
            }
            if ($(this).val() != "" || $(this).is('[readonly]') || $(this).is('[disabled]')) {
                $("." + element + "-label").addClass('floating');
                $(this).addClass('floating');
            }
        });
    }

    function setupDesktop(){
    }

    function setImageAsBackground(thisImage){
        // legacy browser support
        // picturefill();

        // fallback to src for browsers without srcset support
        var src = thisImage.prop('currentSrc') || thisImage.prop('src');
        thisImage.css('display', 'none');
        
        // set the background image for the parent
        var $parent = thisImage.parent();
        $parent.css('background-image', 'url('+src+')');
    }

    // init the MobileResponsive module
    function init() {
        if (isMobileSite()) {
            setupMobileResponsive();
        } else {
            setupDesktop();
        }

        // fix nav bar on scroll
        $(window).scroll(function() {
            if ($(document).scrollTop() > 70) {
                $('#nav').addClass('fixed-top');
                $('#nav').addClass('nav--slim');
            } else if ($(document).scrollTop() < 40)  {
                $('#nav').removeClass('nav--slim');
                $('#nav').removeClass('fixed-top');
            }
        });

        // prevent dropdown hiding by manually triggering dropdowns
        $('.header__nav .nav-link.dropdown-toggle').on('click', function (e) {
             e.preventDefault();
             $('.header__nav .nav-item').not($(this).parent()).removeClass('show');
             $(this).parent().toggleClass('show');
        });

        // load imgix gifs as gifs and bypass imgix.js
        $('img[ix-path$=".gif"]').each(function(index){
            var newSrc = "//" + $("meta[property='ix:host']").attr('content') + "/" + $(this).attr('ix-path');
            $(this).attr('src', newSrc);
            $(this).removeAttr('ix-path');
            $(this).removeAttr('ix-params');
            $(this).removeAttr('srcset');
        });

        // load imgix background imageables
        var $img = $(".imgix-bg");
        if ($img.length) {
            // triggered whenever an image is loaded, including on resize
            $img.each(function(theImage){
                // add crop faces for Mobile
                // if($(this).hasClass('mobile') && isMobileSite()){
                //     var attributes = JSON.parse($(this).attr('ix-params'));
                //     // attributes['crop'] = "faces";
                //     attributes['h'] = 450;
                //     $(this).attr('ix-params',JSON.stringify(attributes));
                // }

                $(this).on('load', function(){
                    // if this is a mobile only pic and we're on a mobile page
                    if($(this).hasClass('mobile-only')){
                        if(isMobileSite()){
                            setImageAsBackground($(this));
                        }
                    // else if this is a desktop only pic and we're on a desktop page
                    } else if ($(this).hasClass('desktop-only')){
                        if(!isMobileSite()){
                            setImageAsBackground($(this));
                        }
                    // else it's a normal pic
                    } else {
                        setImageAsBackground($(this));
                    }
                });
            });
        }

        // toggle search
        $('#search-icon').on('click', toggleSearch);
        $('#full-screen-search, #full-screen-search .close').on('click keyup', function(event) {
            if (event.target == this || event.target.className == 'close' || event.keyCode == 27) {
                toggleSearch()
                //.$('#full-screen-search').removeClass('open');
            }
        });

        // fix flex-wrap
        if (Modernizr.flexbox && Modernizr.flexwrap) {
            // Modern Flexbox with `flex-wrap` supported
        }
        else {
            // Either old Flexbox syntax, or `flex-wrap` not supported

        }
    }

    init();
})();


// Show update browser notification if IE<11, F<40, O<30, S<7 and C<40
var $buoop = {vs:{i:11,f:40,o:30,s:7,c:40},api:4};
function $buo_f(){
    var e = document.createElement("script");
    e.src = "//browser-update.org/update.min.js";
    document.body.appendChild(e);
};
try {document.addEventListener("DOMContentLoaded", $buo_f,false)}
catch(e){window.attachEvent("onload", $buo_f)}

// BOOTSTRAP BROWSER COMPATBILITY
// for IE10 in WP8
if (navigator.userAgent.match(/IEMobile\/10\.0/)) {
    var msViewportStyle = document.createElement('style')
    msViewportStyle.appendChild(
        document.createTextNode(
            '@-ms-viewport{width:auto!important}'
        )
    )
    document.head.appendChild(msViewportStyle)
}

// BOOTSTRAP BROWSER COMPATBILITY
// fix <select> on Android Stock browser
var nua = navigator.userAgent;
var is_android = ((nua.indexOf('Mozilla/5.0') > -1 && nua.indexOf('Android ') > -1 && nua.indexOf('AppleWebKit') > -1) && !(nua.indexOf('Chrome') > -1));
if(is_android) {
    $('select.form-control').removeClass('form-control').css('width', '100%');
}
